export default __webpack_public_path__ + "static/media/funda_v2.a1a286bd.jpg";